<div
  [ngClass]="{
    'bg-base-300': theme() === 'dark',
    'bg-white': theme() === 'light',
    'bg-primary': theme() === 'purple',
    'bg-[#800080]': theme() === 'violet',
  }"
  class="navbar fixed h-screen w-screen flex justify-center items-center"
>
  <button
    [ngClass]="{
      flex: theme() === 'light',
      hidden: theme() !== 'light',
    }"
    (click)="toggleTheme()"
    class="btn bg-transparent hover:bg-transparent w-100 h-fit border-0 w-48 md:w-64 shadow-none"
  >
    <img class="w-full" src="/assets/logo/qwiko-hz-logo-dark.svg" alt="" />
  </button>
  <button
    [ngClass]="{
      flex: theme() !== 'light',
      hidden: theme() === 'light',
    }"
    (click)="toggleTheme()"
    class="btn bg-transparent hover:bg-transparent w-100 h-fit border-0 w-48 md:w-64 shadow-none"
  >
    <img class="w-full" src="/assets/logo/qwiko-hz-logo-light.svg" alt="" />
  </button>
</div>
<router-outlet> </router-outlet>
